import { $axios } from "@/config/axios";

export default {
  fetchDO(params) {
    return $axios.get("ponds/hourly-feed-and-pond-guard-data", { params });
  },
  fetchDOSummary(params) {
    return $axios.get("ponds/dissolved-oxygen-summary", { params });
  },
  fetchTempSummary(params) {
    return $axios.get("ponds/temperature-summary", { params });
  },
  fetchAllParamsOfWaterQuality(pondId, pgId, params) {
    return $axios.get(`ponds/${pondId}/pond-guards/${pgId}/sensor-data`, {
      params,
    });
  },
  fetchAquaLabAllParamsOfWaterQuality(pgId, params) {
    return $axios.get(`ponds/pond-guards/${pgId}/sensor-data`, {
      params,
    });
  },
  fetchLatestDOAndTemp(params) {
    return $axios.get("ponds/do-temperature", { params });
  },
  fetchDoRangeStartDate(params) {
    return $axios.get(
      `ponds/pond-guards/${params.pond_guard_id}/${params.parameter}/range-start-time`,
      { params }
    );
  },
  fetchDoInDateRange(params, pgID) {
    return $axios.get(`ponds/pond-guards/${pgID}/sensor-data`, {
      params,
    });
  },
};
